import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';
import { color } from '../../../Assets/color';
import { colorNames } from '../../../Constants/colors';

export const PhotoZone = styled.div`
    width: 350px;
    height: 200px;
    margin: 16px 0 22px 0;

    background-image: ${props => (props.background ? `url('${props.background}')` : null)};
    background-size: cover;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    border: 3px dashed #2b2b2c;
`;

export const WorkoutPlanZone = styled.div`
    width: 350px;
    height: ${props => (props.isEmpty ? '350px' : '400px')};

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    border: ${props => (props.isEmpty ? '3px dashed #2b2b2c' : null)};
`;

export const StyledButton = styled.button`
    height: 30px;
    padding: 0 20px;

    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    border-radius: 100px;
    outline: none;
    cursor: pointer;

    color: #fff;
    font-size: 14px;
    font-weight: 500;
`;

export const FileLabelButton = styled.label`
    height: 30px;
    padding: 0 20px;

    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    border-radius: 100px;
    outline: none;
    cursor: pointer;

    display: flex;
    align-items: center;

    color: #fff;
    font-size: 14px;
    font-weight: 500;
`;

export const SubmitButton = styled.button`
    height: 46px;
    width: ${props => (props.small ? '91px' : '190px')};

    border-radius: 100px;
    background-color: #fff;
    cursor: pointer;
    outline: none;

    color: #fc3d40;
    font-size: 15px;
    font-weight: 500;
`;

export const AddClassButton = styled.button`
    height: 46px;
    width: ${props => (props.small ? '91px' : '190px')};

    border-radius: 100px;
    background-color: #fff;
    cursor: pointer;
    outline: none;

    color: #fc3d40;
    font-size: 15px;
    font-weight: 500;

    ${media.phone`
        height: 30px;
        width: 60px;
        font-size: 14px;
    `};
`;

export const SelectContainer = styled.div`
    width: 350px;
    background-color: #0e0e0e;
    position: absolute;
    top: 80px;
    left: 0;
    border-radius: 3px;
    border: solid 1px #979797;
    background-color: #000000;
    z-index: 1000;
`;

export const UploadingAvatarContainer = styled.div`
    color: ${color(colorNames.YELLOW)};
    margin-top: 30px;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/forms/style.js